import {FC, ReactNode} from 'react';
import {Typography} from '~library/atoms/Typography';
import './Section.sass';

interface SectionProps {
  title: string;
  children: ReactNode;
}

export const Section: FC<SectionProps> = ({title, children}) => (
  <div className="details-fields__section">
    <Typography variant="label2" color="pebble">
      {title}
    </Typography>
    <div className="details-fields__content">{children}</div>
  </div>
);
